import { Avatar } from '@chakra-ui/react';

/** @typedef {import('@chakra-ui/react').AvatarRootProps} AvatarRootProps */
/** @typedef {{ src?: string, name?: string }} VAvatarOwnProps */
/** @type {(props: AvatarRootProps & VAvatarOwnProps) => import('react').JSX.Element} */
const VAvatar = ({ src, name, children, ...props }) => (
  <Avatar.Root {...props}>
    <Avatar.Fallback name={name}>{children}</Avatar.Fallback>
    {src && <Avatar.Image src={src} alt={name || 'Avatar'} />}
  </Avatar.Root>
);

export default VAvatar;
